import { connect } from 'react-redux';
import InstructorAIPage from './Main';
import { bindActionCreators } from 'redux';
import { authorizedUser } from 'Store/Selectors/AuthSelector';
import {
  getChats,
  getActiveChatUuid,
  getMessages,
  getIsStreaming,
  getStreamBuffer,
  getError,
  getIsConnected,
} from 'Store/Selectors/AiChatSelector';
import {
  connectWebSocket,
  disconnectWebSocket,
  fetchChats,
  createNewChat,
  createNewChatAndSend,
  loadChatHistory,
  sendChatMessage,
  deleteChatAction,
  clearError,
} from 'Store/Actions/AiChat';

type ConnectedP = {
  authorizedUser: any;
  chats: any[];
  activeChatUuid: string | null;
  messages: any[];
  isStreaming: boolean;
  streamBuffer: string;
  error: string | null;
  isConnected: boolean;
};

type DispatchedP = {
  actions: {
    connectWebSocket: () => (dispatch: any, getState: any) => void;
    disconnectWebSocket: () => (dispatch: any) => void;
    fetchChats: () => (dispatch: any) => void;
    createNewChat: () => (dispatch: any) => Promise<any>;
    createNewChatAndSend: (content: string) => (dispatch: any) => void;
    loadChatHistory: (chatUuid: string) => (dispatch: any) => void;
    sendChatMessage: (chatUuid: string, content: string) => (dispatch: any) => void;
    deleteChatAction: (chatUuid: string) => (dispatch: any) => void;
    clearError: () => any;
  };
};

const mapStateToProps = (state) => ({
  authorizedUser: authorizedUser(state),
  chats: getChats(state),
  activeChatUuid: getActiveChatUuid(state),
  messages: getMessages(state),
  isStreaming: getIsStreaming(state),
  streamBuffer: getStreamBuffer(state),
  error: getError(state),
  isConnected: getIsConnected(state),
});

const mapDispatchToProps = (dispatch): DispatchedP => ({
  actions: bindActionCreators(
    {
      connectWebSocket,
      disconnectWebSocket,
      fetchChats,
      createNewChat,
      createNewChatAndSend,
      loadChatHistory,
      sendChatMessage,
      deleteChatAction,
      clearError,
    },
    dispatch,
  ),
});

export type MainType = ConnectedP & DispatchedP;

export default connect(mapStateToProps, mapDispatchToProps)(InstructorAIPage);
